module.exports = __webpack_public_path__ + "static/media/Vault File Server.61ab2b53.png";